// ─────────────────────────────────────────────────────────────────
// Glass-i — Glass Type Master API client (Stage 6B.8A-3M).
//
// Thin axios wrappers around /api/erp/masters/glass-types/*. The
// inline-CRUD page uses `list` to load the grid and `bulkSave` to
// persist all dirty rows + queued deletes in one round-trip.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/glass-types';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const glassTypeApi = {
  list:     (params = {}) => client.get(BASE, { params }).then(unwrap),
  lookups:  (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  get:      (id)          => client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:   (payload)     => client.post(BASE, payload).then(unwrap),
  update:   (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:   (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  reorder:  (payload)     => client.post(`${BASE}/reorder`, payload).then(unwrap),
  bulkSave: (payload)     => client.post(`${BASE}/bulk-save`, payload).then(unwrap)
};

// Convenience for callers that just need a lookup with soft-fail
// (e.g. an Item Master dropdown reading Glass Types).
export async function loadGlassTypeLookupsSafe() {
  try { return await glassTypeApi.lookups(); }
  catch (_e) { return null; }
}

export default glassTypeApi;
